import {Component, OnDestroy, OnInit}               from '@angular/core';
import {Router}                                     from "@angular/router";
import {NgbModal, NgbModalOptions, NgbModalRef}     from "@ng-bootstrap/ng-bootstrap";

import {CheckboxAdminComponent}                     from "../admin/checkbox/checkbox-admin.component";
import {CollegeAdminComponent}                      from "../admin/college/college-admin.component";
import {environment}                                from "../../environments/environment"
import {Message}                                    from '../services/message/message';
import {MessageService}                             from '../services/message/message.service';
import {Permissions}                                from "../services/permissions/permissions";
import {PhrasesAdminComponent}                      from "../admin/phrases/phrases-admin.component";
import {PlayerAdminComponent}                       from "../admin/player/player-admin.component";
import {PositionAdminComponent}                     from "../admin/position/position-admin.component";
import {SourceAdminComponent}                       from "../admin/source/source-admin.component";
import {TagAdminComponent}                          from "../admin/tag/tag-admin.component";
import {TeamAdminComponent}                         from "../admin/team/team-admin.component";
import {User}                                       from "../services/user/user";
import {UserService}                                from "../services/user/user.service";
import {VendorAdminComponent}                       from "../admin/vendor/vendor-admin.component";

import {Subscription}                               from 'rxjs/Subscription';


@Component({
	templateUrl: './articles.component.html',
	styleUrls: ['./articles.component.css'],
})


/**
 * Create the MessageService and the Component.
 *
 * The component contains the ListComponent and
 * holds the message display window.
 *
 * The MessageService is used to display messages
 * that are returned to the user when the user
 * requests that an action be taken.
 */
export class ArticlesComponent implements OnInit, OnDestroy {

	isAdministrator: boolean;
	message: Message;
	modalRef: NgbModalRef;
	subscription: Subscription;
	userName: string = 'Unknown';
	version: string = 'Version ' + environment.version;

	/**
	 * Initialize the MessageService so the message window
	 * can receive messages.
	 *
	 * @param messageService  The MessageService singleton.
	 * @param modalService    Used to pop up admin entries.
	 * @param router          Router used when logging out.
	 * @param userService     Used when logging out of the system.
	 */
	constructor(

		private messageService: MessageService,
	    private modalService: NgbModal,
		private router: Router,
		private userService: UserService

	) {}


	/**
	 * Subscribe to messages.
	 */
	ngOnInit() {

		// Mark the current user as an administrator or non-administrator.
		this.isAdministrator = Permissions.checkPermission(Permissions.SUPER_USER);

		this.subscription = this.messageService.subject.subscribe( message => { this.message = message; } );

		// Set the author information from the session's User variable.
		let userString:string = sessionStorage.getItem('currentUser');
		if (null !== userString) {
			let user:User = new User(JSON.parse(userString));
			if (Permissions.checkPermission(Permissions.SUPER_USER)) {
				this.userName = user.fname + ' ' + user.lname + ' (admin)';
			} else {
				this.userName = user.fname + ' ' + user.lname;
			}
		}

	}


	/**
	 * Unsubscribe to messages when quitting to avoid memory leaks.
	 */
	ngOnDestroy() {

		if (this.subscription) {
			this.subscription.unsubscribe();
		}

	}


	/**
	 * Log out.
	 */
	logout():void {

		this.router.navigate(['/login']).then(
			() => {
				this.userService.logout();
			}
		);

	}


	/**
	 * Used to open the modals for the administration menu entries.
	 *
	 * @param component  The abbreviated name of the component to load.
	 */
	openAdminModal(component: string) {

		let opts: NgbModalOptions = {
			size : 'lg',
		};

		// Limit checkboxes, tags, teams, and vendors to super users.
		let cname: string = component.toLowerCase();
		let admins: string[] = ['checkbox', 'tag', 'team', 'vendor'];
		let is_admin: boolean = Permissions.checkPermission(Permissions.SUPER_USER);

		if ((-1 !== admins.indexOf(cname) && ! is_admin)) {

			window.alert('Contact your administrator if you need to access this menu.');
			return;

		}

		switch(cname) {

			case "checkbox": {

				this.modalRef = this.modalService.open(CheckboxAdminComponent, opts);
				break;

			}

			case "college": {

				this.modalRef = this.modalService.open(CollegeAdminComponent, opts);
				break;

			}

			case "phrases": {

				this.modalRef = this.modalService.open(PhrasesAdminComponent, opts);
				break;

			}

			case "player": {

				this.modalRef = this.modalService.open(PlayerAdminComponent, opts);
				break;

			}

			case "position": {

				this.modalRef = this.modalService.open(PositionAdminComponent, opts);
				break;

			}

			case "source": {

				this.modalRef = this.modalService.open(SourceAdminComponent, opts);
				break;

			}

			case "tag": {

				this.modalRef = this.modalService.open(TagAdminComponent, opts);
				break;

			}

			case "team": {

				this.modalRef = this.modalService.open(TeamAdminComponent, opts);
				break;

			}

			case "vendor": {

				this.modalRef = this.modalService.open(VendorAdminComponent, opts);
				break;

			}

			default: {

				break;

			}

		}

	}


}



// WEBPACK FOOTER //
// ./src/app/articles/articles.component.ts